<template>
<div>
  <navbar/>
  <!-- <b-breadcrumb :items="items"/> -->
  <!-- <contents/> -->
  <!-- <router-link to="/home">Go to home</router-link>
  <router-link to="/about">Go to about</router-link>
  <router-link to="/cont">Go to content</router-link> -->
  <div class = "auto_90">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import Navbar from './Navbar.vue'
// import Tarifs from './Tarifs.vue'

export default {
  data () {
    return {
      items: [{
        text: 'Главная',
        href: '/'
      }, {
        text: 'тарифы',
        href: '/tarifs'
      }, {
        text: 'Library',
        active: true
      }]
    }
  },
	components: {
    Navbar
	}
}



</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.auto_90 {
  width: 90%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue